import React from "react";
import OrganizationUsers from "../../Components/OrganizationSettings/UserManagement/OrganizationUsers";
import NoAccessComponent from "../../Components/Shared/Error/NoAccess";

const WorkspaceUserPage = ({ organization, user, role }) => {
    const authorized = role.roleType === 'Owner' || role.roleType === 'Administrator';
    if (!authorized) {
        return <NoAccessComponent />
    }
    return (
        <OrganizationUsers
            user={user}
            organization={organization}
        />
    );
};

export default WorkspaceUserPage; 
